<template>
  <section class="mb-5">
    <div id="subHeader">
      <h1>Blog</h1>
      <h2>Fique atento</h2>
    </div>
    <div class="container" id="main">
      <div class="" id="text-stuff-title">
        <h3>{{ novidade.title }}</h3>
      </div>
      <div class="d-flex px-3 my-5">
        <div class="m-auto">
          <img alt="" id="qsBanner" :src="novidade.image">
        </div>
      </div>
      <div class="">
        <div id="text-stuff" v-html="novidade.description"></div>
        <div class="docs mt-3" v-if="novidade.documents && novidade.documents.length">
          <h1>Anexos</h1>
          <hr>
          <a v-for="doc in novidade.documents" class="d-block" :href="doc" download="">
            <button class="btn w-100">{{ doc.replace('/storage/novidades/', '') }}</button>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TypeIt from 'typeit';

export default {
  name: "Novidade",
  metaInfo() {
    return {
      title: `Blog | ${this.novidade.title}`,
    }
  },
  data() {
    return {
      novidade: {}
    }
  },
  mounted() {
    this.$parent.image = '/images/novidades.jpg';
  },
  beforeRouteEnter(to, from, next) {
    axios.post(`/novidades/${to.params.id}`)
        .then(rsp => next(vm => {
          vm.novidade = rsp.data;
        }))
  },
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

hr {
  border-color: #fff;
}

#qsBanner {
  max-width: 550px;
}

button.btn {
  text-align: left;
  margin-bottom: 10px;
  padding: 10px 60px 10px 15px;
  background: rgba(0, 0, 0, .35);
  color: #fff;
  position: relative;

  &::before {
    position: absolute;
    top: 10px;
    bottom: 10px;
    right: 5px;
    width: 50px;
    background-image: url('/images/download-icon.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right;
    content: "";
    filter: invert(100%);
  }
}
</style>